import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/prayer-hero.jpg")